import { render, staticRenderFns } from "./ResellerProfile.vue?vue&type=template&id=086da524"
import script from "./ResellerProfile.vue?vue&type=script&lang=js"
export * from "./ResellerProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports